import { useEffect } from 'react';

export default function Refund() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <main className="min-h-screen bg-gradient-to-br from-black via-gray-900 to-black pt-32 pb-20 px-4 sm:px-6">
            <div className="max-w-4xl mx-auto">
                <h1 className="text-4xl md:text-5xl font-bold text-white mb-8">Política de Reembolso</h1>
                <div className="text-gray-300 space-y-6 leading-relaxed">

                    <section>
                        <h2 className="text-2xl font-bold text-yellow-400 mb-4">1. Garantía de Satisfacción o Reembolso</h2>
                        <p>Ofrecemos una garantía de reembolso de 7 días para todas nuestras nuevas suscripciones. Si no está satisfecho con nuestro servicio, puede solicitar un reembolso completo.</p>
                    </section>

                    <section>
                        <h2 className="text-2xl font-bold text-yellow-400 mb-4">2. Condiciones de Elegibilidad</h2>
                        <p>Para ser elegible para el reembolso:</p>
                        <ul className="list-disc pl-6 space-y-2">
                            <li>La solicitud debe realizarse dentro de los 7 días posteriores a la compra.</li>
                            <li>Debe haber contactado a nuestro soporte técnico para intentar resolver cualquier problema encontrado.</li>
                            <li>El problema no debe originarse en su propia conexión a internet (velocidad insuficiente).</li>
                        </ul>
                    </section>

                    <section>
                        <h2 className="text-2xl font-bold text-yellow-400 mb-4">3. Procedimiento de Solicitud</h2>
                        <p>Para solicitar un reembolso, envíe un correo electrónico a support@tvsola.com con su número de pedido y el motivo de su solicitud. Nuestro equipo procesará su solicitud en un plazo de 24 a 48 horas.</p>
                    </section>

                    <section>
                        <h2 className="text-2xl font-bold text-yellow-400 mb-4">4. Plazos de Reembolso</h2>
                        <p>Una vez aprobado el reembolso, los fondos se acreditarán en su método de pago original en un plazo de 5 a 10 días hábiles, según su banco.</p>
                    </section>
                </div>
            </div>
        </main>
    );
}
